import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState,useEffect } from 'react';
export default function AddTasaForm() {
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '-',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNextId = async () => {
            try {
                const response = await axios.get('/tasas');
                const lastId = response.data.reduce((maxId, tasa) => Math.max(maxId, tasa.id), 0);
                setFormData(prev => ({ ...prev, id: lastId + 1 }));
            } catch (error) {
                console.error('Error obteniendo el próximo ID:', error);
            }
        };
        fetchNextId();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación básica
        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.descripcion) validationErrors.descripcion = 'El campo Descripción es obligatorio.';
        if (!formData.aplicacion) validationErrors.aplicacion = 'El campo Aplicación contable es obligatorio';
      //  if (!formData.padron) validationErrors.padron = 'Introduce el valor 1 si es padron o 0 si no lo es.';
      //  if (!formData.recaudador) validationErrors.recaudador = 'Introduce DNI del recaudador.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/tasas', {
                    id: parseInt(formData.id, 10),
                    descripcion: formData.descripcion,
                    aplicacion: formData.aplicacion,
                    padron: formData.padron,
                    recaudador: formData.recaudador,
                    importe: parseFloat(formData.importe)
                });
                navigate('/home/tasas');
            } catch (err) {
                console.error('Error saving tasa:', err);
                setErrors({ submit: 'Error al guardar la tasa. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nueva Tasa</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
                        ID
                    </label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                        placeholder="ID de la tasa"
                    />
                    {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="descripcion">
                        Descripción
                    </label>
                    <input
                        type="text"
                        name="descripcion"
                        value={formData.descripcion}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.descripcion ? 'border-red-500' : ''}`}
                        placeholder="Descripción de la tasa"
                    />
                    {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="aplicacion">
                        Aplicación
                    </label>
                    <input
                        type="text"
                        name="aplicacion"
                        value={formData.aplicacion}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.aplicacion ? 'border-red-500' : ''}`}
                        placeholder="Aplicación contable de la tasa"
                    />
                    {errors.aplicacion && <p className="text-red-500 text-xs italic">{errors.aplicacion}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="padron">
                        Padrón
                    </label>
                    <input
                        type="text"
                        name="padron"
                        value={formData.padron}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.padron ? 'border-red-500' : ''}`}
                        placeholder="Padrón de la tasa"
                    />
                    {errors.padron && <p className="text-red-500 text-xs italic">{errors.padron}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="recaudador">
                        Recaudador
                    </label>
                    <input
                        type="text"
                        name="recaudador"
                        value={formData.recaudador}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.recaudador ? 'border-red-500' : ''}`}
                        placeholder="Recaudador de la tasa"
                    />
                    {errors.recaudador && <p className="text-red-500 text-xs italic">{errors.recaudador}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="importe">
                        Importe
                    </label>
                    <input
                        type="text"
                        name="importe"
                        value={formData.importe}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.importe ? 'border-red-500' : ''}`}
                        placeholder="Importe de la tasa"
                    />
                    {errors.importe && <p className="text-red-500 text-xs italic">{errors.importe}</p>}
                </div>
                {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Tasa'}
                    </button>
                </div>
            </form>
        </div>
    );
}



/* CORRECTO
import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import React, { useState } from 'react';
export default function AddTasaForm() {
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validación básica
        const validationErrors = {};
        if (!formData.id) validationErrors.id = 'El campo ID es obligatorio.';
        if (!formData.descripcion) validationErrors.descripcion = 'El campo Descripción es obligatorio.';
        if (!formData.aplicacion) validationErrors.aplicacion = 'El campo Aplicación es obligatorio.';
     //   if (!formData.padron) validationErrors.padron = 'El campo Padrón es obligatorio.';
        if (!formData.recaudador) validationErrors.recaudador = 'El campo Recaudador es obligatorio.';
        if (!formData.importe) validationErrors.importe = 'El campo Importe es obligatorio.';

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.post('/tasas', {
                    id: parseInt(formData.id, 10),
                    descripcion: formData.descripcion,
                    aplicacion: formData.aplicacion,
                    padron: formData.padron,
                    recaudador: formData.recaudador,
                    importe: parseFloat(formData.importe)
                });
                navigate('/home/tasas');
            } catch (err) {
                console.error('Error saving tasa:', err);
                setErrors({ submit: 'Error al guardar la tasa. Por favor, intente de nuevo.' });
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6">Añadir Nueva Tasa</h2>
            <form onSubmit={handleSubmit} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="id">
                        ID
                    </label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.id ? 'border-red-500' : ''}`}
                        placeholder="ID de la tasa"
                    />
                    {errors.id && <p className="text-red-500 text-xs italic">{errors.id}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="descripcion">
                        Descripción
                    </label>
                    <input
                        type="text"
                        name="descripcion"
                        value={formData.descripcion}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.descripcion ? 'border-red-500' : ''}`}
                        placeholder="Descripción de la tasa"
                    />
                    {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="aplicacion">
                        Aplicación
                    </label>
                    <input
                        type="text"
                        name="aplicacion"
                        value={formData.aplicacion}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.aplicacion ? 'border-red-500' : ''}`}
                        placeholder="Aplicación de la tasa"
                    />
                    {errors.aplicacion && <p className="text-red-500 text-xs italic">{errors.aplicacion}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="padron">
                        Padrón
                    </label>
                    <input
                        type="text"
                        name="padron"
                        value={formData.padron}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.padron ? 'border-red-500' : ''}`}
                        placeholder="Padrón de la tasa"
                    />
                    {errors.padron && <p className="text-red-500 text-xs italic">{errors.padron}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="recaudador">
                        Recaudador
                    </label>
                    <input
                        type="text"
                        name="recaudador"
                        value={formData.recaudador}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.recaudador ? 'border-red-500' : ''}`}
                        placeholder="Recaudador de la tasa"
                    />
                    {errors.recaudador && <p className="text-red-500 text-xs italic">{errors.recaudador}</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="importe">
                        Importe
                    </label>
                    <input
                        type="text"
                        name="importe"
                        value={formData.importe}
                        onChange={handleChange}
                        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${errors.importe ? 'border-red-500' : ''}`}
                        placeholder="Importe de la tasa"
                    />
                    {errors.importe && <p className="text-red-500 text-xs italic">{errors.importe}</p>}
                </div>
                {errors.submit && <p className="text-red-500 text-xs italic mb-4">{errors.submit}</p>}
                <div className="flex items-center justify-between">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Guardando...' : 'Guardar Tasa'}
                    </button>
                </div>
            </form>
        </div>
    );
}

*/